import { IApplicationContext } from 'shared/types/applicationContext';

import { ResponseError } from 'shared/errors';
import {
  fetchCianApiSiteV1GetRegionCities,
  ICianApiSiteV1GetRegionCitiesRequest,
  TCianApiSiteV1GetRegionCitiesResponse,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-region-cities';
import { ILocation } from 'shared/types/location';

export async function fetchCitiesByRegion(
  context: IApplicationContext,
  parameters: ICianApiSiteV1GetRegionCitiesRequest,
): Promise<ILocation[]> {
  const {
    httpApi,
    custom: { subdomain },
  } = context;

  const { response, statusCode }: TCianApiSiteV1GetRegionCitiesResponse = await fetchCianApiSiteV1GetRegionCities({
    httpApi,
    parameters,
    config: {
      subdomain,
    },
  });

  if (statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchCitiesByRegion',
      message: response.data.message || '',
      details: {
        error: JSON.stringify(response.data.errors),
      },
    });
  }

  return response.data.items || [];
}
